import CommonPagination from 'components/StaticPage/CommonPagination/CommonPagination.vue'
import chunk from 'lodash/chunk'
import filter from 'lodash/filter'
import sortBy from 'lodash/sortBy'
import removeAccents from 'remove-accents'

/**
 * Defined limit to show items
 */
const defaultLimit = 5

export default {
  name: 'cities-by-country',

  components: {
    CommonPagination
  },

  props: {
    citiesByCountry: null,
    showCities: {
      type: Boolean,
      default: false
    },
    routeName: {
      type: String,
      default: 'routes.locations'
    },
    routeParams: {
      type: Object
    },
    h2Title: {
      type: Boolean,
      default: false
    },
    nomeComPreposicao: {
      type: String
    }
  },

  data() {
    return {
      citiesPage: 1,
      citiesLimit: 99999,
      locale: this.$store.getters.getLocale,
      globalPageLocale: this.$store.getters.getIsBrazilianLocale,
      citiesFilter: null
    }
  },

  computed: {
    /**
     * @desc returns a list of cities
     */
    computedCities() {
      const that = this

      this.citiesByCountry = this.citiesByCountry.map((value) => {
        value.Nome = value.LocalidadeI18n[this.$i18n.locale]
        return value
      })

      let cities = sortBy(this.citiesByCountry, value => removeAccents(value.Nome))

      if (this.citiesFilter && this.citiesFilter.length) {
        cities = filter(cities, function (city) {
          const lowerCity = removeAccents(city.Nome.toLowerCase())

          return lowerCity.indexOf(that.citiesFilter.toLowerCase()) >= 0
        })
      }

      return chunk(cities, this.citiesLimit)
    },

    /**
     * @desc returns if is airport
     *
     * @returns {boolean}
     */
    isAirportLocation() {
      return !!this.routeParams.airportSlug
    }
  },

  mounted() {
    this.citiesLimit = defaultLimit
  },

  methods: {
    /**
     * @desc update page number for cities
     *
     * @param newPageNumber
     */
    updateCitiesPageNumber(newPageNumber) {
      this.citiesPage = newPageNumber
    },

    /**
     * @desc return route name
     *
     * @param params
     * @return {string}
     */
    buildRouteName(params) {
      return params.is_airport ? this.$routeResolver('routes.rental-airport') : this.routeName
    },

    /**
     * @desc returns route params
     *
     * @param params
     * @return {object}
     */
    buildRouteParams(params) {
      if (this.isAirportLocation) {
        params.locationSlug = this.routeParams.airportSlug
      }

      return Object.assign({}, this.routeParams, params)
    },

    /**
     * @desc return a flag css class
     *
     * @param countryCode
     * @return {string}
     */
    flagIcon: function (countryCode) {
      return `flag-icon flag-icon-${countryCode.toLowerCase()}`
    }
  }
}
